/* eslint-disable react/react-in-jsx-scope */
import axios from 'axios'
import { useQuery } from 'react-query'
import { API_URL } from '../../config'
import { rqDefaultOptions } from './defaultOptions'

const getCTBPartsTable = async (inputObj) => {
  const { project, parentPart } = inputObj.queryKey[1]
  const clearToBuildTableAPIPath = `${API_URL}/api/ctb/v1/ctbParts?parentPart=${parentPart.partNumber}&project=${project}`

  const res = await axios.get(clearToBuildTableAPIPath).catch((err) => console.error(err))

  return res.data
}

export function useCTBPartsTable(project, parentPart, setCtbData, formatColumns) {
  const options = {
    enabled: !!parentPart,
    onSuccess: (resData) => {
      let { data = [], columns = [] } = resData
      columns = formatColumns(columns)

      // let nz = 0
      // for (let i = 0; i < data.length; i++) {
      //   if (data[i].partType) nz += 1
      // }

      // if (nz == 0) {
      //   // Keep Description column; only widen PN when no partType present
      //   columns[1].cellStyle.maxWidth = 200
      // } else {
      //   columns.splice(2, 0, { title: 'Type', field: 'partType' })
      //   columns[1].cellStyle.maxWidth = 135
      // }

      setCtbData({
        data,
        columns: columns,
      })
    },
    ...rqDefaultOptions,
  }
  return useQuery(['ctbParts', { project, parentPart }], getCTBPartsTable, options)
}
